import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SelectedOption } from '@cpm-pr1618001/ng-design-lib';
import { DashboardFacade } from '../dashboard/store/facade/dashboard.facade';
import { ContactPayload } from '../dashboard/store/state/dashboard.state';
import { InitFacade } from '../store/facade/init.facade';
import { UserManagementFacade } from '../store/user-management/facade/user-management.facade';
import { HeaderComponent } from './header.component';

@Component({
  selector: 'fm-header',
  imports: [CommonModule, HeaderComponent],
  templateUrl: './header.container.component.html',
  styleUrl: './header.container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderContainerComponent {
  userDropdownList$ = this.userManagementFacade.getUserDropdownList$;
  accountInfo$ = this.initFacade.accountInfo$;
  notifications$ = this.userManagementFacade.notifications$;
  messages$ = this.userManagementFacade.messages$;
  isAddContactProcessing$ = this.dashboardFacade.isAddContactProcessing$;

  constructor(
    private readonly initFacade: InitFacade,
    private readonly userManagementFacade: UserManagementFacade,
    private readonly dashboardFacade: DashboardFacade,
  ) {}

  selectedOption(selectedOption: SelectedOption): void {
    if (selectedOption.value === 'Logout') {
      this.userManagementFacade.logOutUser();
    } else {
      this.userManagementFacade.selectedMenuDropdownOption(selectedOption);
    }
  }

  addChosenContact(payload: ContactPayload): void {
    this.dashboardFacade.addChosenContact(payload);
  }

  onLoadMoreNotifications(offsetLimit: number): void {
    const limit: number = offsetLimit <= 10 ? 11 : offsetLimit;
    const reload: boolean = offsetLimit === 0;
    this.userManagementFacade.getNotifications(limit, limit + 10, reload);
  }
}
